import type { AlbumType, PhotoType } from '../types/models';
import { API_V2_ACCESS_TOKEN, API_V2_URL } from '../core/common';
import axios from 'axios';

export function apiAlbumsGet({
  cancelToken,
  limit,
  offset,
}: {
  cancelToken: any;
  limit: number;
  offset: number;
}) {
  let url =
    API_V2_URL +
    `/photo/albums?access_token=${API_V2_ACCESS_TOKEN}&limit=${limit}&offset=${offset}`;

  return new Promise<{ albums: AlbumType[]; count: number }>((resolve, reject) => {
    axios
      .get(url, {
        cancelToken,
        headers: {
          Accept: 'application/json',
        },
      })
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        if (!axios.isCancel(error)) {
          reject(error);
        }
      });
  });
}

export function apiPhotosGet({
  cancelToken,
  limit,
  offset,
}: {
  cancelToken: any;
  limit: number;
  offset: number;
}) {
  let url =
    API_V2_URL + `/photo?access_token=${API_V2_ACCESS_TOKEN}&limit=${limit}&offset=${offset}`;

  return new Promise<{ photos: PhotoType[]; count: number }>((resolve, reject) => {
    axios
      .get(url, {
        cancelToken,
        headers: {
          Accept: 'application/json',
        },
      })
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        if (!axios.isCancel(error)) {
          reject(error);
        }
      });
  });
}

export function apiPhotoGetUploadLink(fileName: string, user_id: number) {
  return new Promise<string>((resolve, reject) => {
    axios
      .get(
        API_V2_URL +
          `/photos.get_upload_link?access_token=${API_V2_ACCESS_TOKEN}&file_name=${fileName}&user_id=${user_id}`,
        {
          headers: {
            Accept: 'application/json',
          },
        }
      )
      .then(function (response) {
        resolve(response.data.albums);
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

export function apiPhotoGetPartners(album_id: number) {
  return new Promise<
    {
      name: string;
      id: number;
      send: 0 | 1 | 2;
    }[]
  >((resolve, reject) => {
    axios
      .get(
        API_V2_URL +
          `/partner/photo_partners?access_token=${API_V2_ACCESS_TOKEN}&album_id=${album_id}`,
        {
          headers: {
            Accept: 'application/json',
          },
        }
      )
      .then(function (response) {
        resolve(response.data.partners);
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

export function apiPhotoSend(album_id: number, partner_id: number) {
  return new Promise<boolean>((resolve, reject) => {
    axios
      .post(
        API_V2_URL + `/partner/send_album?access_token=${API_V2_ACCESS_TOKEN}`,
        {
          album_id,
          partner_id,
        },
        {
          headers: {
            Accept: 'application/json',
          },
        }
      )
      .then(function (response) {
        resolve(response.data.status);
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

export function apiPhotoRemove(album_id: number, partner_id: number) {
  return new Promise<boolean>((resolve, reject) => {
    axios
      .post(
        API_V2_URL + `/partner/remove_album?access_token=${API_V2_ACCESS_TOKEN}`,
        {
          album_id,
          partner_id,
        },
        {
          headers: {
            Accept: 'application/json',
          },
        }
      )
      .then(function (response) {
        resolve(response.data.status);
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

export function apiAlbumAccept(album_id: number) {
  return new Promise<boolean>((resolve, reject) => {
    axios
      .post(
        API_V2_URL + `/photo/album/accept?access_token=${API_V2_ACCESS_TOKEN}`,
        {
          album_id,
        },
        {
          headers: {
            Accept: 'application/json',
          },
        }
      )
      .then(function (response) {
        resolve(response.data.status);
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

export function apiAlbumDecline(album_id: number) {
  return new Promise<boolean>((resolve, reject) => {
    axios
      .post(
        API_V2_URL + `/photo/album/decline?access_token=${API_V2_ACCESS_TOKEN}`,
        {
          album_id,
        },
        {
          headers: {
            Accept: 'application/json',
          },
        }
      )
      .then(function (response) {
        resolve(response.data.status);
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

export function apiAlbumHold(album_id: number) {
  return new Promise<boolean>((resolve, reject) => {
    axios
      .post(
        API_V2_URL + `/photo/album/hold?access_token=${API_V2_ACCESS_TOKEN}`,
        {
          album_id,
        },
        {
          headers: {
            Accept: 'application/json',
          },
        }
      )
      .then(function (response) {
        resolve(response.data.status);
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

export function apiPhotoUpdateMetadata(photoId: number, metadata: any) {
  return new Promise<boolean>((resolve, reject) => {
    axios
      .post(
        API_V2_URL + `/photo/update_metadata?access_token=${API_V2_ACCESS_TOKEN}`,
        {
          photoId,
          values: metadata,
        },
        {
          headers: {
            Accept: 'application/json',
          },
        }
      )
      .then(function (response) {
        resolve(response.data.status);
      })
      .catch(function (error) {
        reject(error);
      });
  });
}
